import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { Multilingual } from 'src/app/services/multilingual';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import * as Highcharts from 'highcharts';
import { Chart } from 'angular-highcharts';
import * as moment from 'moment';
import { StockChart } from 'angular-highcharts';
import { Options } from 'highcharts';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
@Component({
  selector: 'app-energy-dashboard',
  templateUrl: './energy-dashboard.component.html',
  styleUrls: ['./energy-dashboard.component.scss']
})
export class EnergyDashboardComponent implements OnInit {
  engDashboardForm!: FormGroup;
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  activeButton!: any;
  dashboardData!: any;
  totalPower!:any;
  totalCurrent!:any;
  totalVoltage!:any;
  totalPowerChart!: Chart;
  totalCurrentChart!:Chart;
  totalVoltageChart!:Chart;
  totalPowerChart1!:Chart;
  options: any;
  stock!: Chart;
  chart!: any;
  highChartsColor = [
    '#00008B',
    '#34A56F',
    '#F80000',
    '#2D0A77',
    '#8C001A',
    '#FF69B4',
    '#FA4A08',
    '#5453A6',
    '#8B008B',
    '#3090C7',
    '#F1C40F',
    '#CB4335',
    '#36454F',
    '#A569BD',
    '#FFA500',
    '#179fcc',
    '#093323',
    '#08fa03',
    '#048b8e',
    '#9637A4',
    '#F39C12',
    '#0b774e',
    '#F5B7B1',
    '#0d98da',
    '#512E5F',
    '#C471A5',
    '#0034bb',
    '#06573d',
    '#0d6e54',
    '#0692aa',
    '#611745',
    '#F80000',
    '#FFDF00',
    '#6D81A8',
    '#08FAC7',
    '#D208FA',
    '#FAEB08',
  ];  
  format = 'YYYY-MM-DD HH:mm:ss';
    // iconUrl
    menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
    menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
    menuBlueIconUrl = 'assets/images/menu-bottom-blue-icon.png';
  constructor(
    private formBuilder: FormBuilder,
    private kpiMaster: KpimasterService,
    private toaster: ToastrService,
    private usermanagementService: UserManagementService,
    private productivityservice: ProductivityService,
    private spinner: NgxSpinnerService,
    public router: Router,
    private translater: TranslaterService,
    private translate: TranslateService,
  
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.datasource();
  }

  initForm() {
    const dateStart = new Date();
    //dateStart.setDate(dateStart.getDate() - 183);
    dateStart.setHours(6);
    dateStart.setMinutes(0);
    dateStart.setSeconds(0);

    const dateEnd = new Date();
    dateEnd.setDate(dateEnd.getDate());

    this.engDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      interval: [5, []],
      searchval: [''],
    });
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  onChangeGroup(data: any): void {
    this.getPlants(data);
  }
  onChangeLine(data: any): void {
    this.getUnit(data.value);
  }
  onChangePlant(data: any): void {
    this.getLine(data.value);
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        //this.gridApi.refreshHeader();
      }
    });
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  showPhase(event: any) {
    this.activeButton = event;
  }

  onSubmit(): void {
  this.getEnergyDashboard();
  }

  getEnergyDashboard() {
    const key = {
      startDate: this.engDashboardForm.value.dateStart,
      endDate: this.engDashboardForm.value.dateEnd,
      puId: this.engDashboardForm.value.unit,
      min:this.engDashboardForm.value.interval
    };
    this.spinner.show();
    this.productivityservice.GetEnergyDashboard(key).subscribe(
      (data: any) => {
        this.dashboardData = data;
        this.totalPower=this.dashboardData?.Table[0]?.totalPower?.toFixed(2);
        this.totalCurrent=this.dashboardData?.Table[0]?.totalCurrent?.toFixed(2);
        this.totalVoltage=this.dashboardData?.Table[0]?.totalVoltage?.toFixed(2);
        this.spinner.hide();
        this.drawTotalPowerTrends();
        this.drawCurrentPowerTrends();
        this.drawVoltageTrends();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    );
  }


  datasource(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          id.value = data.lstEG[0].EG_Id;
            this.engDashboardForm.patchValue({
              UserGroup1: data.lstEG[0].EG_Id,
              UserPlant1: data.lstEG[0].EG_Id,
            });
          this.filteredGroups = this.GroupList.slice();
          this.getPlants(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: this.engDashboardForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;
            this.engDashboardForm.get('UserPlant1')?.patchValue(id);
          this.getLine(id);
          this.filteredPlants = this.PlantList1.slice();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getLine(id: any) {
    const key = {
      PT_ID: this.engDashboardForm.value.UserPlant1,
      userId: 206,
    };

    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {
        this.lineList = data.lstLine;
        if (this.lineList.length > 0) {
          const lineDefault = this.lineList[0];
            this.engDashboardForm.controls.line.patchValue(lineDefault.PL_Id);
          this.filteredLines = this.lineList.slice();
          this.getUnit(lineDefault.PL_Id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnit(id: number) {
    const key = {
      PL_ID: this.engDashboardForm.value.line,
      userId: 206,
    };

    this.productivityservice.getUnitData(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
          const unitDefault = this.unitList[0];
            this.engDashboardForm.controls.unit.patchValue(unitDefault.PU_Id);
          this.filteredUnits = this.unitList.slice();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getMili(Start_Time: any) {
    var date = moment(Start_Time).format(this.format);
    return new Date(date).getTime();
  }

  drawTotalPowerTrends() {
    const data:any[]=[];
    this.dashboardData.Table3.forEach(element => {
      data.push([this.getMili(element.Time),element.TotalPower]);
    });

    this.options = {
      chart: {
        zoomType: 'x'
    },
    title: {
        text: ''
    },
    xAxis: {
        type: 'datetime'
    },
    yAxis: {
        title: {
            text: 'Power Trends'
        }
    },
    legend: {
        enabled: false
    },
    credits:{
      enabled:false
    },
    plotOptions: {
        area: {
            fillColor: {
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1
                },
                stops: [
                    [0, Highcharts.getOptions().colors[0]],
                    [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                ]
            },
            marker: {
                radius: 2
            },
            lineWidth: 1,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
            threshold: null
        }
    },

    series: [{
        type: 'area',
        name: 'Power',
        data: data
    }]
    };
    let chart = new Chart(this.options);
    this.totalPowerChart = chart;
  }
  drawCurrentPowerTrends() {
    const yAxisArr: any[] = [];
    const array: any[] = [];
    const names = ['Phase A', 'Phase B', 'Phase C'];
    var data:any[]=[];
    data = this.dashboardData.Table1;
    for (let i = 0; i < names.length; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if (names[i] === 'Phase A') {
          dataArr.push({x: this.getMili(data[j].Time),y: parseFloat(data[j].A),label: 'Phase A'});
        }
        if (names[i] === 'Phase B') {
          dataArr.push({x: this.getMili(data[j].Time),y: parseFloat(data[j].B),label: 'Phase B'});
        }
        if (names[i] === 'Phase C') {
          dataArr.push({x: this.getMili(data[j].Time),y: parseFloat(data[j].C),label: 'Phase C'});
        }
      }
      let negativeArr = [];
      console.log(dataArr);
      negativeArr = dataArr.map((c) => c.y);
      const obj = {
        tooltip: {
          valueDecimals: 2,
        },
        name: names[i],
        type: 'line',
        data: dataArr,
        color: this.highChartsColor[i],
        yAxis: i,
      };
      if(obj.data.length>0){
        array.push(obj);
      }
      yAxisArr.push({
        lineWidth: 1,
        visible:true,
       // opposite:false,
        opposite: negativeArr.some((v) => v < 0) ? true : false,
        title: {
          text: names[i],
          style: {
            color: this.highChartsColor[i],
          },
        },
        labels: {
          style: {
            color: this.highChartsColor[i],
          },
        },
      });
    }
    yAxisArr.forEach((yAxis) => { // hide y axis
      yAxis.visible = false;
    });
    // creating chart
    Highcharts.stockChart('totalCurrentChart', {

      rangeSelector: {
          selected: 4
      },
      yAxis:yAxisArr,
      plotOptions: {
          series: {
              compare: 'percent',
              showInNavigator: true,
              turboThreshold: 1000000,
          },
      },
      credits:{
        enabled:false
      },
      legend:{
        enabled:true
      },
      tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
          valueDecimals: 2,
          split: true
      },

      series: array
  });
  }

  drawVoltageTrends() {
    const yAxisArr: any[] = [];
    const array: any[] = [];
    const names = ['Phase A', 'Phase B', 'Phase C'];
    var data:any[]=[];
    data = this.dashboardData.Table2;
    for (let i = 0; i < names.length; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if (names[i] === 'Phase A') {
          dataArr.push({x: this.getMili(data[j].Time),y: parseFloat(data[j].A),label: 'Phase A'});
        }
        if (names[i] === 'Phase B') {
          dataArr.push({x: this.getMili(data[j].Time),y: parseFloat(data[j].B),label: 'Phase B'});
        }
        if (names[i] === 'Phase C') {
          dataArr.push({x: this.getMili(data[j].Time),y: parseFloat(data[j].C),label: 'Phase C'});
        }
      }
      let negativeArr = [];
      console.log(dataArr);
      negativeArr = dataArr.map((c) => c.y);
      const obj = {
        tooltip: {
          valueDecimals: 2,
        },
        name: names[i],
        type: 'line',
        data: dataArr,
        color: this.highChartsColor[i],
        yAxis: i,
      };
      if(obj.data.length>0){
        array.push(obj);
      }
      yAxisArr.push({
        lineWidth: 1,
        visible:true,
       // opposite:false,
        opposite: negativeArr.some((v) => v < 0) ? true : false,
        title: {
          text: '',//kpiNames[i],
          style: {
            color: this.highChartsColor[i],
          },
        },
        labels: {
          style: {
            color: this.highChartsColor[i],
          },
        },
      });
    }
    yAxisArr.forEach((yAxis) => { // hide y axis
      yAxis.visible = false;
    });
    // creating chart
    Highcharts.stockChart('totalVoltageChart', {

      rangeSelector: {
          selected: 4
      },
      yAxis:yAxisArr,
      plotOptions: {
          series: {
              compare: 'percent',
              showInNavigator: true,
              turboThreshold: 1000000,
          }
      },
      credits:{
        enabled:false
      },
      legend:{
        enabled:true
      },
      tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
          valueDecimals: 2,
          split: true
      },

      series: array
  });
  }

}
